import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/whitepapers/")({
  head: () => buildRouteHead("/es/whitepapers/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/downloads", replace: true, statusCode: 301 });
  },
});
